import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'

export function GetCustomers(keyword) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Customers,
    {
        params: {keyword},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetServiceDurations() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.ServiceDurations,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function CancelAppointment(appointmentId, cancelAppointmentOption, cancelAppointmentBy) {
    console.log(appointmentId)
    const appointmentToCancel = {
        appointmentId,
        cancelAppointmentOption,
        cancelAppointmentBy
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.CancelAppointment, appointmentToCancel,
    {
        headers: {
            "Content-Type": "application/json"
        },

        withCredentials: true
    });
}

export function SendCommunication(
    CommunicationType,
    AppointmentId,
    Message,
    ) {

    const customerCommunicationDetails = {
        CommunicationType,
        AppointmentId,
        Message
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.CustomerCommunication, customerCommunicationDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function EditAppointment(
    appointmentId,
    customerId,
    barberId,
    serviceId,
    startDateTime,
    endDateTime,
    durationTimeBlock,
    appointmentNotes,
    customerFirstName,
    customerLastName,
    customerMobile,
    customerEmail,
    customerNotes,
    customerIsBlocked,
    createdBy,
    force = false
    ) {
        
    const appointmentDetails = {
        appointmentId,
        customerId,
        barberId,
        serviceId,
        startDateTime,
        endDateTime,
        durationTimeBlock,
        appointmentNotes,
        customerFirstName,
        customerLastName,
        customerMobile,
        customerEmail,
        customerNotes,
        customerIsBlocked,
        createdBy,
        force
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Appointment, appointmentDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetEvents(dateTime) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Events,
    { 
        params: {dateTime},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetServices() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Services,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function AddCustomer(
    firstName,
    lastName,
    mobile,
    email,
    customerNotes,
    customerIsBlocked,
    ) {

    const customerDetails = {
        firstName,
        lastName,
        mobile,
        email,
        customerNotes,
        customerIsBlocked,
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Customer, customerDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetAppointments(
    customerId
    ) {

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Appointments,
    {
        params: { customerId },
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}